import { Component, Input } from '@angular/core'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser'
import { SessionService, UtilService } from '@exchange/services/.'
import { IControlTooltip, Permissions } from '@exchange/domain/.'
import { ITooltipComponent, TooltipService } from './tooltip.service'
import { ToastrService } from 'ngx-toastr'

@Component({
  selector: 'app-tooltip',
  templateUrl: './tooltip.component.html',
  standalone: false
})
export class TooltipComponent implements ITooltipComponent {
  private _form = ''
  private _uid = ''

  public get form(): string {
    return this._form
  }
  @Input() public set form(value: string) {
    this._form = value
    this.register()
  }
  public get uid(): string {
    return this._uid
  }
  @Input() public set uid(value: string) {
    this._uid = value
    this.register()
  }
  @Input() public absolute = false
  @Input() public position: {
    left?: number
    top?: number
  } = {}

  public get left(): string {
    if (this.absolute) {
      const numLeft = +this.position.left
      if (!isNaN(numLeft)) {
        return `${numLeft}px`
      }
    }

    return 'auto'
  }

  public get top(): string {
    if (this.absolute) {
      const numTop = +this.position.top
      if (!isNaN(numTop)) {
        return `${numTop}px`
      }
    }

    return 'auto'
  }

  visible = false
  canEdit = false
  editMode = false
  saving = false

  public value: IControlTooltip = {
    Id: 0,
    Title: '',
    Text: ''
  } as IControlTooltip
  public get text(): SafeHtml {
    return this.domSanitizer.bypassSecurityTrustHtml(this.value.Text)
  }

  public editorModules: {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'], // toggled buttons
      [{ header: 1 }, { header: 2 }], // custom button values
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ['link', 'image', 'video'],
      ['clean']
    ]
  }

  constructor(
    private session: SessionService,
    private service: TooltipService,
    private domSanitizer: DomSanitizer,
    private toastr: ToastrService,
    private util: UtilService
  ) {
    this.session.isPermissionGranted(Permissions.PageHelpEdit).subscribe(value => {
      this.canEdit = value
    })
  }

  show(): void {
    setTimeout(() => {
      if (this.value.Id) {
        this.visible = true
      } else if (this.canEdit) {
        this.editMode = true
        if (!this.value.Id) {
          this.value.Form = this.form
          this.value.Uid = this.uid
        }
      }

      if (this.visible || this.editMode) {
        this.service.current = this
      }
    }, 10)
  }

  hide(): void {
    this.visible = false
    this.editMode = false
  }

  switchMode(): void {
    if (this.canEdit) {
      if (this.visible && !this.value.Id) {
        this.value.Form = this.form
        this.value.Uid = this.uid
      }
      this.visible = !this.visible
      this.editMode = !this.editMode
    }
  }

  register(): void {
    if (this.form && this.uid) {
      this.service.register(this)
    }
  }

  save(): void {
    const errors = []

    if (!this.value.Title) {
      errors.push('Tooltip Title is required.')
    }

    if (!this.value.Text) {
      errors.push('Tooltip Text is required.')
    }

    this.toastr.clear()
    if (errors.length > 0) {
      this.toastr.error(errors.join('<br />'))
      return
    }

    this.saving = true
    this.service.update(
      this,
      response => {
        this.value = response as IControlTooltip
        this.switchMode()
        this.saving = false
      },
      this.showError
    )
  }

  showError(response): void {
    this.saving = false
    const msg = this.util.getErrorString(response)

    this.toastr.error(msg)
  }
}
